var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentUploadLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4459 8.09667L23.5841 4.52667C22.8841 3.86166 21.9625 3.5 20.9942 3.5H10.1558C8.05579 3.5 6.34082 5.21497 6.34082 7.31502V27.685C6.34082 29.785 8.05579 31.5 10.1558 31.5H24.8441C26.9441 31.5 28.6592 29.785 28.6592 27.685V10.8966C28.6592 9.83499 28.2158 8.82 27.4459 8.09667ZM13.6908 13.09C16.8449 9.93591 16.7354 10.0298 16.8525 9.95163C17.0391 9.82331 17.2725 9.75332 17.4942 9.75332H17.5058C17.8092 9.75332 18.1008 9.88163 18.3225 10.0917C19.5384 11.3123 21.4314 13.2127 21.3092 13.09C21.7641 13.545 21.7641 14.28 21.3092 14.735C20.8542 15.19 20.1192 15.19 19.6641 14.735L18.6725 13.7433V17.8617C18.6725 18.515 18.1475 19.0283 17.5058 19.0283C16.8525 19.0283 16.3392 18.515 16.3392 17.8617V13.7433L15.3358 14.7467C14.8993 15.1832 14.1549 15.2107 13.6908 14.7467C13.2358 14.2917 13.2358 13.545 13.6908 13.09ZM22.0208 25.2467H12.9792C12.3375 25.2467 11.8125 24.7217 11.8125 24.08C11.8125 23.4383 12.3375 22.9133 12.9792 22.9133H22.0208C22.6625 22.9133 23.1875 23.4383 23.1875 24.08C23.1875 24.7217 22.6625 25.2467 22.0208 25.2467Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUploadLogo);
export default __webpack_public_path__ + "static/media/document-upload-logo.7ebeae50c35d8adbce1e455d9fd6f4f3.svg";
export { ForwardRef as ReactComponent };